import camelcaseKeys from "src/utils/camelCaseKeys";

const adaptObservationQuestions = (questions?: IObservationQuestion[]) => {
	if (!questions) return [];

	const observationQuestions: ObservationQuestion[] = questions.map(
		(question) => {
			const { order } = question;

			const newQuestion: ObservationQuestion = {
				...camelcaseKeys(question),
				branches: question.branches,
				questionNumber: order,
				questionType: question.question_type,
				givenAnswer: ""
			};

			return newQuestion;
		}
	);

	return observationQuestions;
};

export default adaptObservationQuestions;
